/**
 * Banner 1059 — KUK home referral band.
 * Full-bleed artwork with a highlighted headline, a supporting line and a small
 * gradient pill CTA. No metadata rows.
 */

export const BANNER_1059_CONSTANTS = {
  BANNER_FIELDS_CONFIG: [
    {
      fieldName: "background_image",
      label: "Artwork (1080px and up)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload desktop artwork",
      defaultValue: "",
    },
    {
      fieldName: "background_image_mobile",
      label: "Artwork (below 1080px)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Optional — uses the desktop artwork if empty",
      defaultValue: "",
    },
    {
      fieldName: "image_alt",
      label: "Artwork alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      fieldName: "title",
      label: "Headline",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Chance to earn {50%} of your course fee back",
      description:
        "Wrap a phrase in { } to paint the highlight chip behind it, as in the reference.",
      defaultValue: "",
    },
    {
      fieldName: "title_color",
      label: "Headline colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title_highlight_color",
      label: "Highlight chip colour",
      value: "#E26C24",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#E26C24",
    },
    {
      fieldName: "description",
      label: "Supporting line",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Invite your friends to join and get exclusive bonuses…",
      defaultValue: "",
    },
    {
      fieldName: "description_color",
      label: "Supporting line colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "icon",
      label: "CTA icon",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Icon name or an image URL",
      defaultValue: "",
    },
    {
      fieldName: "alt_icon",
      label: "CTA icon alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      fieldName: "apply_now_show",
      label: "Show CTA button",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
    {
      fieldName: "apply_now_text",
      label: "CTA label",
      value: "Start referring Now!",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Start referring Now!",
      defaultValue: "Start referring Now!",
    },
    {
      fieldName: "apply_now_is_cta",
      label: "Is CTA (lead popup)",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "On = open lead capture popup instead of the CTA URL",
      defaultValue: true,
    },
    {
      fieldName: "apply_now_link",
      label: "CTA URL (used when Is CTA is off)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "/refer or https://…",
      defaultValue: "",
    },
    {
      fieldName: "apply_now_color",
      label: "CTA text colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "gradient_color_1",
      label: "CTA gradient — start",
      value: "#B0325E",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#B0325E",
    },
    {
      fieldName: "gradient_color_2",
      label: "CTA gradient — end",
      value: "#FAA681",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FAA681",
    },
    {
      fieldName: "gradient_color_3",
      label: "CTA gradient angle",
      value: "47deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "47deg",
      defaultValue: "47deg",
    },
    {
      fieldName: "status",
      label: "Banner status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
